import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../../shared/store/rootReducer';

const selectInitialDataState = (state: RootState) => state.initialData;

// eslint-disable-next-line import/prefer-default-export
export const selectEntityInitialData = createSelector(
  [selectInitialDataState],
  (initialDataState) => initialDataState.initialData
);

export default selectEntityInitialData;
